import { Component } from '@angular/core'; // NgZone

@Component({ selector: 'app-home', templateUrl: './home.component.html', styleUrls: ['./home.component.scss'] })
export class HomeComponent {

  constructor(
  ) { }

  public onTabSelect(e) {
    console.log(e);
  }
}
